// colorMap.js

const COLOR_MAP = {
        // === Base Colors ===
    '--color-white': '#FFFFFF',
    '--color-white-20': '#FFFFFF0F',
    '--color-black': '#000000',
    '--color-black-20': '#0B1F470D',
  /* Colors */
  "--color-headings": "#242C3B",
  "--color-headings-blue": "#0B1F47",
  "--color-body": "#303B4F",
  "--color-body-dark-mode": "#D8D8E0",
  "--color-light": "#FFFFFF",
  "--color-action": "#318FFF",
  "--color-action-hover": "#2440BD",
  "--color-disabled": "#636E82",
  "--color-information": "#5929AB",
  "--color-success": "#387440",
  "--color-warning": "#FF7B00",
  "--color-error": "#CB3030",
  "--color-on-action": "#FFFFFF",
  "--color-on-disabled": "#242C3B",

    // === Grey ===
    '--color-grey-25': '#F1F2F4',
    '--color-grey-50': '#EBEDEF',
    '--color-grey-100': '#D8DBE0',
    '--color-grey-200': '#B1B7C1',
    '--color-grey-300': '#8A92A1',
    '--color-grey-400': '#636E82',
    '--color-grey-500': '#3C4A63',
    '--color-grey-600': '#303B4F',
    '--color-grey-700': '#242C3B',
    '--color-grey-800': '#181E28',
    '--color-grey-900': '#0C0F14',
  
   /* Text Colors */
  "--text-headings": "#242C3B",
  "--text-headings-blue": "#0B1F47",
  "--text-body-grey": "#6D7991",
  "--text-body": "#303B4F",
  "--text-body-dark": "#D8D8E0",
  "--text-light": "#FFFFFF",
  "--text-action": "#318FFF",
  "--text-action-hover": "#2440BD",
  "--text-disabled": "#636E82",
  "--text-information": "#5929AB",
  "--text-success": "#387440",
  "--text-warning": "#FF7B00",
  "--text-error": "#CB3030",
  "--text-on-action": "#FFFFFF",
  "--text-on-disabled": "#242C3B",

  /* Surface Colors */
  "--surface-page": "#F1F2F4",
  "--surface-notification": "#7A54BC",
  "--surface-panel": "#0B1F47",
  "--surface-light": "#D6E9FF",
  "--surface-dark": "#030915",
  "--surface-dark-chat": "#12161E",
  "--surface-panel-dark": "#06122a",
  "--surface-dark-top": "#071531",
  "--surface-dark-2": "#12161E",
  "--surface-neutral": "#F1F2F4",
  "--surface-hover": "#F1F2F4",
  "--surface-primary": "#FFFFFF",
  "--surface-success": "#DFF3E1",
  "--surface-disabled": "#D8D8E0",
  "--surface-warning": "#FFD8B8",
  "--surface-error": "#FE5C5C",
  "--surface-information": "#DED4EE",
  "--surface-action": "#318FFF",
  "--surface-action-hover": "#2772CC",
  "--surface-page-dark": "#050f23",



  /* Button Colors */
  "--btn-primary": "#0B1F47",
  "--btn-primary-dm": "#0c1e47",
  "--btn-hover": "#3C4C6C",
  "--btn-active": "#318FFF",
  "--btn-unactive": "#D8D8E0",
  "--btn-information": "#5929AB",
  "--btn-success": "#5EC16A",
  "--btn-warning": "#FF7B00",
  "--btn-error": "#FE3C3C",

  /* Border Colors */
  "--border-primary": "#D8D8E0",
  "--border-intermediary": "#636E82",
  "--border-information": "#5929AB",
  "--border-success": "#5EC16A",
  "--border-warning": "#FF7B00",
  "--border-error": "#FE3C3C",
  "--border-disabled": "#3C4A63",
  "--border-action": "#318FFF",
  "--border-action-hover": "#318FFF",
  "--border-focus": "#318FFF",
  "--border-light": "solid 0.5px rgba(216, 219, 224, 0.26)",

  /* Chat Bubble */
  "--chat-bubble": "#0B1F47",
   "--chat-bubble-dark": "rgba(255, 255, 255, 0.1);",

  /* Tag Colors */
  "--tag-01": "#318FFF",
  "--tag-02": "#2772CC",
  "--tag-03": "#2440BD",
  "--tag-04": "#1D3397",
  "--tag-05": "#5929AB",
  "--tag-06": "#351967",
  "--color-dark-hover": "#40404070",
};

export default COLOR_MAP;

export const getColor = (colorName) => {
  return COLOR_MAP[colorName] || null;
};
